import apiClient from './apiClient';
import { ENDPOINTS } from './apiConfig';

/**
 * ------------------------------------------------------------------
 * SERVICIO DE EMPLEADOS
 * ------------------------------------------------------------------
 * Maneja todas las operaciones CRUD para empleados
 * ------------------------------------------------------------------
 */

const empleadosService = {
    /**
     * Obtener todos los empleados
     * @param {string} empresaRif - RIF de la empresa
     * @returns {Promise<Array>} Lista de empleados
     */
    getAll: async (empresaRif) => {
        try {
            const params = empresaRif ? { empresa_rif: empresaRif } : {};
            const response = await apiClient.get(ENDPOINTS.EMPLEADOS, { params });
            return response.data || response;
        } catch (error) {
            console.error('Error fetching empleados:', error);
            throw error;
        }
    },

    /**
     * Obtener un empleado por RIF
     * @param {string} rif - RIF del empleado
     * @param {string} empresaRif - RIF de la empresa
     * @returns {Promise<Object>} Datos del empleado
     */
    getByRif: async (rif, empresaRif) => {
        try {
            const params = empresaRif ? { empresa_rif: empresaRif } : {};
            const response = await apiClient.get(ENDPOINTS.EMPLEADO_BY_RIF(rif), { params });
            return response.data || response;
        } catch (error) {
            console.error(`Error fetching empleado ${rif}:`, error);
            throw error;
        }
    },

    /**
     * Crear un nuevo empleado
     * @param {Object} empleado - Datos del empleado
     * @returns {Promise<Object>} Empleado creado
     */
    create: async (empleado) => {
        try {
            const response = await apiClient.post(ENDPOINTS.EMPLEADOS, empleado);
            return response.data || response;
        } catch (error) {
            console.error('Error creating empleado:', error);
            throw error;
        }
    },

    /**
     * Actualizar un empleado existente
     * @param {string} rif - RIF del empleado
     * @param {Object} empleado - Datos actualizados
     * @returns {Promise<Object>} Empleado actualizado
     */
    update: async (rif, empleado) => {
        try {
            const response = await apiClient.put(ENDPOINTS.EMPLEADO_BY_RIF(rif), empleado);
            return response.data || response;
        } catch (error) {
            console.error(`Error updating empleado ${rif}:`, error);
            throw error;
        }
    },

    /**
     * Eliminar un empleado
     * @param {string} rif - RIF del empleado
     * @param {string} empresaRif - RIF de la empresa
     * @returns {Promise<void>}
     */
    delete: async (rif, empresaRif) => {
        try {
            const params = empresaRif ? { empresa_rif: empresaRif } : {};
            await apiClient.delete(ENDPOINTS.EMPLEADO_BY_RIF(rif), { params });
        } catch (error) {
            console.error(`Error deleting empleado ${rif}:`, error);
            throw error;
        }
    }
};

export default empleadosService;
